export const RoofTypes = {
    FlatRoof: 1
};

export const RoofOrientation = {
    Auto: 1, XAxis: 2, ZAxis: 3
};
